export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiUrlDoubleSlash: `${process.env.REACT_APP_API_BASE_URL}/api`,
  googleClientID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
};
